import React, { FC, useRef } from 'react';
import { Box, Popover, ProgressBarMulti, ProgressBarMultiSize } from '@bechtel/gds';
import { ProgressContainerStyled } from '../styled';
import { PlanningTargetCalcProgressProps } from './types';
import { TargetHourPopperContent } from './popper';
import { bankersRound } from '@bechtel/client-common';

export const PlanningTargetCalcProgress: FC<PlanningTargetCalcProgressProps> = ({
  indirectTax,
  projectAdjustmentFactor,
  compositeUnitRate,
}) => {
  const iconRef = useRef<HTMLDivElement>(null);
  const refs = {
    iconRef,
  };
  const targetValue = 5000 + (indirectTax * 5000) / 100 + (projectAdjustmentFactor * 5000) / 100;
  return (
    <>
      <ProgressContainerStyled>
        <ProgressBarMulti
          data={[
            {
              label: '',
              value: bankersRound(targetValue * 0.9, 0),
              fillColor: 'green.400',
            },
          ]}
          bgColor={'white'}
          borderColor={'white'}
          totalValue={targetValue * 2.5}
          units="Hrs"
          showTargetIndicator={true}
          showPercentage={false}
          targetValue={targetValue}
          labelColor={'white'}
          size={ProgressBarMultiSize.MEDIUM}
          ref={refs}
          style={{ position: 'absolute', width: '130%', left: '-70px' }}
        />
      </ProgressContainerStyled>
      <Box
        mt={{ sm: '500' }}
        css={`
          height: 200px;
          background-color: ${({ theme }) => theme.colors.grey[100]};
        `}
      >
        <Box
          css={`
            box-shadow: inset 0px 15px 11px -12px rgb(140 140 140 / 96%);
            width: 100%;
          `}
        ></Box>
      </Box>
      {refs.iconRef && (
        <Popover triggerComponentRef={refs.iconRef} placement="bottom" showPopper={true} customStyle={{ zIndex: 1 }}>
          <TargetHourPopperContent
            indirectTax={indirectTax}
            projectAdjustmentFactor={projectAdjustmentFactor}
            compositeUnitRate={compositeUnitRate}
          />
        </Popover>
      )}
    </>
  );
};
